import { useEffect, useState } from "react";
import { message } from "antd";
import CrudHeader from "../CrudHeader";
import ProveedoresTable from "./ProveedoresTable";
import ProveedoresForm from "./ProveedoresForm";
import { getProveedores, createProveedor, updateProveedor, deleteProveedor } from "../../../../services/financiero/finProveedoresService";
import { useSelector } from 'react-redux';
import { selectAppPermissions } from '../../../../store/auth/selectors';
export default function ProveedoresPage() {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const appName = 'proveedores_financiero';
  const permissions = useSelector((state) => selectAppPermissions(state, appName));
  const user = useSelector((state) => state.auth.user);
  const userLogin = user.username;
  const permissionAccess = permissions.priv_access === 'Y';
  const permissionDelete = permissions.priv_delete === 'Y';
  const permissionUpdate = permissions.priv_update === 'Y';
  const permissionInsert = permissions.priv_insert === 'Y';

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await getProveedores();
      setData(res);
    } catch (error) {
      message.error("Error cargando proveedores");
    }
    setLoading(false);
  };

  useEffect(() => {
    cargar();
  }, []);

  const handleCreate = () => {
    if (!permissionInsert) {
      message.warning("No tiene permisos para crear proveedores");
      return;
    }
    setEditing(null);
    setModalOpen(true);
  };

  const handleEdit = (record) => {
    if (!permissionUpdate) {
      message.warning("No tiene permisos para editar");
      return;
    }
    setEditing(record);
    setModalOpen(true);
  };

  const handleDelete = async (record) => {
    if (!permissionDelete) {
      message.warning("No tiene permisos para eliminar");
      return;
    }
    try {
      await deleteProveedor(record.oid, userLogin);
      message.success("Proveedor eliminado");
      cargar();
    } catch {
      message.error("Error eliminando proveedor");
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (editing) {
        await updateProveedor(
          editing.oid,
          values,
          userLogin
        );
        message.success("Proveedor actualizado");
      } else {
        await createProveedor(
          values,
          userLogin
        );
        message.success("Proveedor creado");
      }
      setModalOpen(false);
      cargar();
    } catch {
      message.error("Error guardando proveedor");
    }
  };

  if (!permissionAccess) {
    return <div>No tiene permisos para acceder a este módulo</div>;
  }
  return (
    <div>
      <CrudHeader
        title="Proveedores Financieros"
        onCreate={handleCreate}
        permissionInsert={permissionInsert}
      />
      <div style={{ maxWidth: 1000, margin: "0 auto", }}>
        <ProveedoresTable
          data={data}
          loading={loading}
          onEdit={handleEdit}
          onDelete={handleDelete}
          permissionDelete={permissionDelete}
          permissionUpdate={permissionUpdate}
        />
      </div>
      <ProveedoresForm
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        onSubmit={handleSubmit}
        initialValues={editing}
      />
    </div>
  );
}